import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js";
import { useHistory } from 'react-router-dom';
import { invokePostService, invokeGetService, setReRender, setFocusElement } from '../../../store/global/actions';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { getDetailsFromUrl } from '../../../services/blueprint'
import './style.css';


const options = {
    form_name_root: "simulation_transaction_configuration",
    show_errors: "never",
    disable_array_add: true,
    disable_array_delete: true,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
}

export default function TransactionConfiguration({ element, onClose, onCompletion }) {

    const dispatch = useDispatch();
    const history = useHistory();


    const [schemaValues, setSchemaValues] = useState({});
    const [isFetching, setIsFetching] = useState(false);
    const [formData, setFormData] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const { slug, blueprintId, entityId } = getDetailsFromUrl();



    const fetchSimulationTransaction = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getSimulationTransaction', [element.simulation_transaction_id])).then(response => {
            if (response.status) {
                const configurations = response.data?.configuration;
                const schemaData = {
                    preDelay: configurations?.preDelay ? configurations.preDelay : "",
                    postDelay: configurations?.postDelay ? configurations.postDelay : "",
                    repeat: configurations?.repeat ? configurations.repeat : "",
                }
                setSchemaValues(schemaData);
            }
            setIsFetching(false);
        });
    }

    useEffect(() => {
        fetchSimulationTransaction();
    }, [element])


    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };



    const schema = {
        type: 'object',
        required: [],
        options: {
            layout: 'grid',
            disable_properties: false
        },
        properties: {
            preDelay: {
                type: "string",
                title: "Pre Delay (milliseconds)",
                format: "grid",
                options: {
                    layout: 'grid',
                    grid_columns: 12,
                }
            },
            postDelay: {
                type: "string",
                title: "Post Delay (milliseconds)",
                format: "grid",
                options: {
                    layout: 'grid',
                    grid_columns: 12,
                }
            },
            repeat: {
                type: "string",
                title: "Repeat",
                format: "grid",
                options: {
                    layout: 'grid',
                    grid_columns: 12,
                }
            }
        }
    }


    const onChangeJsonEditor = (data) => {
        setFormData(data);

        // For customising properties button 
        const configForm = document.querySelector(`[data-schemapath="simulation_transaction_configuration"]`);
        if (configForm) {
            const propertiesBtn = configForm.querySelectorAll('.json-editor-btn-edit_properties.json-editor-btntype-properties');
            if (propertiesBtn?.length > 0) {
                propertiesBtn.forEach(btn => {
                    btn.textContent = "Choose Configuration";
                    btn.title = "Choose Configuration";
                });
            }

        }
    }

    const onUpdateConfiguration = () => {
        setIsUpdating(true);

        dispatch(invokePostService('updateSimulationTransactionConfiguration', { configurations: formData, testsuiteId: entityId }, [element.testcase_id, element.simulation_transaction_id])).then(response => {
            setIsUpdating(false);
            if (response.status == true) {
                dispatch(setFocusElement({}));
                onCompletion('Testcase configuration ', 'edit');
            } else {
                if (response.code === 255) {
                    const { slug, blueprintId } = getDetailsFromUrl();
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                }
            }
        });

    }



    return (
        <>
            {isFetching ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="configuration_editor" />
            }
            <Grid item xs={12} style={isFetching ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
                <UpdateCancel updateDisable={isUpdating || isFetching} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdateConfiguration} onCancel={onClose} typesNotIn={['transaction', 'view', 'simulation']} />
            </Grid>
        </>
    )
}